/**
 * Formats a Date object into a localized string representation
 * @param date - The date to format
 * @returns A formatted string representation of the date
 */
export const formatTimestamp = (date: Date): string => {
    return date.toLocaleString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  };
  
  /**
   * Formats a Date object into a shorter time-only representation
   * @param date - The date to format
   * @returns A formatted time string
   */
  export const formatTimeOnly = (date: Date): string => {
    return date.toLocaleTimeString(undefined, {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  };
  
  /**
   * Truncates text with ellipsis if it exceeds the maximum length
   * @param text - The text to truncate
   * @param maxLength - Maximum allowed length
   * @returns Truncated text with ellipsis or original text
   */
  export const truncateText = (text: string, maxLength: number): string => {
    if (!text) return '';
    return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
  };